// Opaque, URL-path-safe encoding for the `section` route param.
// Section keys like `ocr/{sectionId}` / `ai/{sectionId}` contain a literal `/`,
// which nginx-ingress decodes from `%2F` back to `/` before Express routing,
// silently adding an extra path segment and breaking route matching (404).
// Base64url has no `/` in its alphabet, so it survives the ingress unchanged.
// Must stay in lockstep with vvsi-web-api/src/utils/sectionParam.ts.

export function encodeSectionParam(section: string): string {
  const bytes = new TextEncoder().encode(section)
  let binary = ''
  bytes.forEach((b) => { binary += String.fromCharCode(b) })
  return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '')
}

export function decodeSectionParam(encoded: string): string {
  let base64 = encoded.replace(/-/g, '+').replace(/_/g, '/')
  while (base64.length % 4) base64 += '='
  const binary = atob(base64)
  const bytes = Uint8Array.from(binary, (c) => c.charCodeAt(0))
  return new TextDecoder().decode(bytes)
}
